/**
 * Recognise known SQL Server error phrases in a raw connect-error string.
 *
 * The `connect-to-database` IPC stringifies `error.message`, dropping the
 * structured `RequestError.number` and driver `code` extracted in the main
 * process. SQL Server emits stable English messages from the server, so
 * phrase-matching is reliable and lets the renderer route connect failures
 * through the same `connectionDiagnosticsErrorMap` used by the listing-time
 * diagnostics dialog — keeping the wording consistent across the two paths.
 *
 * Order is most-specific first: the Azure firewall message also matches
 * "Cannot open server", and Azure SQL Edge sometimes wraps a 4060 ("Cannot
 * open database") response as a bare "Login failed for user" — when both
 * phrases are present, the database phrase wins.
 */

export type RecognisedSqlError = {
  sqlErrorCode?: number;
  driverCode?: string;
};

export function recogniseSqlConnectError(text: string): RecognisedSqlError {
  if (
    /Cannot open server/i.test(text) &&
    /(is not allowed to access|firewall rule)/i.test(text)
  ) {
    return { sqlErrorCode: 40615 };
  }
  if (/Cannot open database/i.test(text)) return { sqlErrorCode: 4060 };
  if (/Login failed for user/i.test(text)) return { sqlErrorCode: 18456 };
  if (/\bELOGIN\b/.test(text)) return { driverCode: 'ELOGIN' };
  return {};
}
